import * as React from "react";
import { FunctionComponent } from "react";
import { Accommodation, ColorScheme, ActionLinkItem } from "../types";
import { getActionAndContactLinks } from "../utils/utils";
import SmartLink from "./SmartLink";
import Icon from "./Icon";
import { style } from "typestyle";
import * as ClassNames from "classnames";

interface Props {
  isPreview: boolean;
  actionLinks: ActionLinkItem[];
  accommodation: Accommodation | undefined;
  scheme: ColorScheme;
}

const HeaderActionBottomBar: FunctionComponent<Props> = ({
  accommodation,
  actionLinks,
  isPreview,
  scheme,
}) => {
  const items = getActionAndContactLinks(accommodation, actionLinks);
  if (!items.length) return null;

  return (
    <div
      className={ClassNames(
        "HeaderActionBottomBar",
        style({
          backgroundColor: scheme.main.background,
          color: scheme.main.text,
        })
      )}
    >
      <ul className="HeaderActionBottomBar__List">
        {items.map(({ children, icon, href }) => (
          <li className="HeaderActionBottomBar__ListItem" key={href}>
            <SmartLink
              isPreview={isPreview}
              anchorAttrs={{
                href,
                className: "HeaderActionBottomBar__LinkItem",
              }}
            >
              <Icon glyph={icon} className="HeaderActionBottomBar__Icon" />
              <span className="HeaderActionBottomBar__Text">{children}</span>
            </SmartLink>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HeaderActionBottomBar;
